import type { Technique } from '../types';
import { HATCHING_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type HatchingState } from './render';

export const hatching: Technique<HatchingState> = {
  id: 'hatching',
  name: 'Schraffur',
  category: 'deconstruction',
  description: 'Füllt die Buchstaben mit Schraffurlinien, wahlweise mit Überstand und Kreuzlagen.',
  params: HATCHING_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
